import Repository from './Repository';
import { Raffle, CustomerRaffle } from '@comsbi/common/src/types/models';

const resource = '/raffle';

export default {
  /**
   * 顧客抽選会データ解決
   */
  resolveCustomerRaffle(raffleId: string) {
    return Repository.post(`${resource}/${raffleId}/resolve`);
  },
  /**
   * スタンプ付与(顧客抽選会データがなければ解決してから付与)
   */
  giveTicket(raffleId: string, numTickets: number, shopChannelId?: string) {
    return Repository.post(`${resource}/${raffleId}/ticket`, { numTickets, shopChannelId });
  },
  /**
   * 抽選(オンライン)
   */
  drawOnline(raffleId: string, numDraws: number) {
    return Repository.post(`${resource}/${raffleId}/draw_online`, { numDraws });
  },
  /**
   * 抽選(オフライン)
   */
  drawOffline(raffleId: string, numDraws: number) {
    return Repository.post(`${resource}/${raffleId}/draw_offline`, { numDraws });
  },
  /**
   * 抽選履歴
   */
  loadHistory(raffleId: string, from: number, limit: number) {
    return Repository.get(`${resource}/${raffleId}/history`, { params: { from, limit } });
  },
};
